import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { fadeUp, Section } from "./shared";

export const FinalCTA = ({ onCheckEligibility }) => (
  <Section className="pb-24">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <motion.div variants={fadeUp} className="rounded-[2.5rem] bg-[#052F24] text-[#F6F5F2] p-10 sm:p-20 text-center relative overflow-hidden grain">
        <h2 className="font-display font-extrabold text-4xl sm:text-6xl tracking-tighter leading-[0.95] max-w-3xl mx-auto">
          Your best funding option is <span className="text-[#DFFF00]">two minutes</span> away.
        </h2>
        <button
          onClick={onCheckEligibility}
          data-testid="footer-cta"
          className="group mt-10 inline-flex items-center gap-2 bg-[#DFFF00] text-[#052F24] font-bold text-lg px-8 py-4 rounded-full hover:bg-white transition-colors"
        >
          Check my eligibility
          <ArrowUpRight size={20} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
        </button>
        <p className="mt-5 text-sm text-[#F6F5F2]/50">No credit impact · FCA-regulated lenders · Free to use</p>
      </motion.div>
    </div>
  </Section>
);
